import {Service} from "../Service";

export class GarantiaService extends Service{
    constructor() {
        super('garantias/');
    }


    guardarSolicitud(solicitud) {
        return this.http.post(this.getUrl(['guardar', 'solicitud']),solicitud)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerSolicitud(idSolicitud) {
        return this.http.post(this.getUrl(['obtener', 'solicitud']), idSolicitud)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerQuejas(filtro) {
        return this.http.post(this.getUrl(['obtener', 'quejas']),filtro)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerOrigenQuejas() {
        return this.http.get(this.getUrl(['catalogo', 'origen']))
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerMotivos() {
        return this.http.get(this.getUrl(['catalogo', 'motivos']))
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerDrivers() {
        return this.http.get(this.getUrl(['catalogo', 'drivers']))
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerTema(idDriverQueja) {
        return this.http.post(this.getUrl(['catalogo', 'temas']), idDriverQueja)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerSubTema(idTemaQueja) {
        return this.http.post(this.getUrl(['catalogo', 'subtemas']), idTemaQueja)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerTicket(idTicket) {
        return this.http.post(this.getUrl(['obtener', 'queja']), idTicket)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerDatosAdicionales(idPaciente) {
        return this.http.post(this.getUrl(['obtener', 'datos-adicionales', 'dictamen-operaciones']), idPaciente)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerDictamen(idSolicitud) {
        return this.http.post(this.getUrl(['obtener', 'dictamen-operaciones']), idSolicitud)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerDictamenDental(idSolicitud) {
        return this.http.post(this.getUrl(['obtener', 'dictamen-dental']), idSolicitud)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerRegistroContacto(idSolicitud) {
        return this.http.post(this.getUrl(['obtener', 'registro-contacto']), idSolicitud)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerIntentos(idSolicitud) {
        return this.http.post(this.getUrl(['obtener', 'intentos']), idSolicitud)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    guardarIntentos(intento) {
        return this.http.post(this.getUrl(['guardar', 'intento']),intento)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    actualizarDictamenDental(envio,idEtapa) {
        return this.http.post(this.getUrl(['guardar', 'dictamen-dental'], {idEtapa: idEtapa}),envio)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    guardarDictamen(envio, idEtapa) {
        return this.http.post(this.getUrl(['guardar', 'dictamen-operativo'],{idEtapa:idEtapa}),envio)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    actualizarDictamen(envio) {
        return this.http.put(this.getUrl(['actualizar', 'dictamen-operativo']),envio)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    dictamenAprobado(respuesta,solicitud, idEtapa) {
        return this.http.post(this.getUrl(['dictamen', 'aprobado'], {aprobado: respuesta, idSolicitud: solicitud, idEtapa: idEtapa}), {})
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    guardarDatosComplemtarios(envio) {
        return this.http.post(this.getUrl(['solicitud', 'complementos'], envio), {})
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    guardarSolicitudEtapa(envio) {
        return this.http.post(this.getUrl(['guardar', 'solicitud-etapa'], envio), {})
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    finalizar(envio) {
        return this.http.post(this.getUrl(['garantia', 'finalizar'], envio), {})
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    cerrarCaso(idTicket, idEtapa) {
        return this.http.post(this.getUrl(['cerrar', 'caso'], {idSolicitud: idTicket, idEtapa: idEtapa}), {})
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    guardarGarantia(envio, garantias) {
        return this.http.post(this.getUrl(['guardar','garantia'], envio), garantias)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerQuejasPaciente(idPaciente) {
        return this.http.post(this.getUrl(['obtener', 'quejas', 'paciente']), idPaciente)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerDictamenesParaClinicas(idClinica) {
        return this.http.post(this.getUrl(['obtener', 'garantias', 'dentales','clinica']), idClinica)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerTratamientosDictamen(idDictamen) {
        return this.http.post(this.getUrl(['obtener', 'tratamientos', 'dictamen']), idDictamen)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerDatosPacienteYTratamientosRealizados(idPaciente) {
        return this.http.post(this.getUrl(['obtenerDatosPaciente']),idPaciente)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    enviarMesaServicio(idDictamen,lista) {
        return this.http.post(this.getUrl(['guardar', 'dictamen', 'realizado'],{idDictamen:idDictamen}),lista)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    guardarSolicitudDental(idSolicitud, idEtapa, solicitud,) {
        return this.http.post(this.getUrl(['guardar', 'solicitud', 'dental'],{idSolicitud,idEtapa}),solicitud)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerSolicitudDental(idSolicitud) {
        return this.http.post(this.getUrl(['obtener', 'solicitud', 'dental']), idSolicitud)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al obtener los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerEspecialistas(idSolicitud) {
        return this.http.post(this.getUrl(['obtener', 'especialistas']), idSolicitud)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al obtener los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerEspecialistasEvaluacion(parametros) {
        return this.http.post(this.getUrl(['obtener', 'especialistas','evaluacion']), parametros)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al obtener los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerImputados(idSolicitud) {
        return this.http.post(this.getUrl(['obtener', 'imputados']), idSolicitud)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al obtener los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerTipoGarantiaDental() {
        return this.http.get(this.getUrl(['obtener', 'tipo-garantias']))
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al obtener los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerRubro() {
        return this.http.get(this.getUrl(['obtener', 'rubros']))
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al obtener los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerResoluciones() {
        return this.http.get(this.getUrl(['obtener', 'resolucion']))
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al obtener los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    guardarEspecialistas(idSolicitud, idEtapa, registros) {
        return this.http.post(this.getUrl(['guardar', 'especialistas'],{idSolicitud,idEtapa}),registros)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    guardarEvaluacion(idSolicitud, idEtapa, idSolicitudTratamientoGarantia, registros) {
        return this.http.post(this.getUrl(['guardar', 'evaluacion'],{idSolicitud,idEtapa, idSolicitudTratamientoGarantia}),registros)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    irDictamen(idSolicitud, idEtapa, idEmpleado) {
        return this.http.post(this.getUrl(['ir', 'dictamen'],{idSolicitud,idEtapa, idEmpleado}))
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    guardarDictamenDental(idSolicitud, idEtapa, idEmpleado, body) {
        return this.http.post(this.getUrl(['guardar', 'dictamen'],{idSolicitud,idEtapa, idEmpleado}),body)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerDictamenAntarior(idSolicitud) {
        return this.http.post(this.getUrl(['obtener', 'dictamen']), idSolicitud)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    completarherramientas(idSolicitud, idEtapa) {
        return this.http.post(this.getUrl(['completar', 'herramientas'],{idSolicitud,idEtapa}))
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }


    obtenerDictamenes(filtros) {
        return this.http.post(this.getUrl(['obtener-dictamenes']), filtros)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al realizar consulta')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerRegistrosMSI(filtros){
        return this.http.post(this.getUrl(['obtener-registrosMSI']), filtros)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al realizar consulta')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

}
